import Popup from 'react-popup';
import intl from 'react-intl-universal';

export function productHasBarcode(product) {
  if (!product) return false;
  return Boolean(product.barcode) || (product.additional_barcodes_ids || []).length > 0;
}

export function isScanRequiredEnabled(config) {
  return config.product_confirmation_method === 'scan_click' &&
    Boolean(config.require_scan_for_products_with_barcode);
}

export function isScanRequired(config, product) {
  return isScanRequiredEnabled(config) && productHasBarcode(product);
}

export function isScanRequiredForLine(config, product) {
  if (!isScanRequiredEnabled(config)) return false;
  return productHasBarcode(product) || (product.items || []).some(productHasBarcode);
}

export function isElementScanRequired(element) {
  return Boolean(element) && element.dataset.scanRequired === '1';
}

export function isMouseEvent(event) {
  return Boolean(event && event.isTrusted);
}

export function showScanRequiredPopup() {
  Popup.create({
    content: intl.get('Ten produkt ma kod kreskowy - zeskanuj go'),
    buttons: {
      right: [
        {
          text: 'OK',
          className: 'ok',
          key: 'enter',
          action: () => {
            Popup.close();
            const scanner = document.getElementById('scanner');
            if (scanner) scanner.focus();
          },
        },
      ],
    },
  });
}

export function setManualConfirmation(element, isManual) {
  if (!element) return;
  if (isManual) {
    element.dataset.manual = '1';
  } else {
    delete element.dataset.manual;
  }
}

export function collectManualConfirmations() {
  const confirmations = [];

  document.querySelectorAll('.produkt.ramka[data-manual="1"]').forEach(produkt => {
    const productCheckbox = produkt.querySelector('.product_checkbox');
    const mainCheckbox = produkt.querySelector('.mainCheckbox');
    if (!productCheckbox || !mainCheckbox || !mainCheckbox.classList.contains('checked')) return;
    confirmations.push({
      line_id: parseInt(productCheckbox.dataset.line, 10) || false,
      product_id: parseInt(productCheckbox.dataset.product, 10) || false,
      qty: parseFloat(produkt.dataset.prods) || 0,
    });
  });

  document.querySelectorAll('.bundleItem[data-manual="1"]').forEach(bundleItem => {
    const checkbox = bundleItem.querySelector('.checkbox.multiproduct');
    const produkt = bundleItem.closest('.produkt.ramka');
    if (!checkbox || !checkbox.classList.contains('checked') || !produkt) return;
    const productCheckbox = produkt.querySelector('.product_checkbox');
    confirmations.push({
      line_id: productCheckbox ? parseInt(productCheckbox.dataset.line, 10) || false : false,
      product_id: parseInt(bundleItem.dataset.productId, 10) || false,
      qty: (parseFloat(produkt.dataset.prods) || 1) * (parseFloat(bundleItem.dataset.qty) || 1),
    });
  });

  return confirmations.filter(confirmation => confirmation.product_id);
}
